export default {
  login_register: 'Bejelentkezés/Regisztráció',
  booking_confirmation_title: 'Foglalás visszaigazolása',
  booking_confirmation_body: 'Köszönjük foglalását. A visszaigazolás részleteit az alábbiakban olvashatja.',
  insurance_requirements_modal_disclaimer: `A foglalással megerősítem, hogy: Nem voltam elítélve, illetve nem követtem el közlekedési szabálysértést
    az elmúlt 5 évben. Ajánlatkérésemet nem utasították el, nem érvénytelenítették szerződésemet, nem utasították el   a szerződés megújítási kérelmemet,
    nem kellett megemelt díjat fizetnem, és egyik gépjármű-biztosító sem szabott ki rám különleges feltételeket.
    Nem tiltottak el a gépjárművezetéstől. Nem folyik ellenem büntetőeljárás vagy rendőrségi nyomozás.
    Az elmúlt 5 évben nem ítéltek el lopás, csalás vagy tisztességtelenség miatt.
    Nem szenvedek látás- vagy halláskárosulástól (amit szemüveggel vagy hallókészülékkel korrigáltak volna), szívbetegségben,
    cukorbetegségben, rohamoktól és nincsen semmilyen fizikai vagy szellemi fogyatékosságom.
    Az elmúlt 5 évben nem szenvedtem balesetet. Kérjük, kattintson a {0} gombra, amennyiben nem felel meg ezeknek a feltételeknek.`,
  insurance_requirements_here: 'Itt',
  insurance_requirements: 'Biztosítási igények itt: Elolvastam és megértettem a {0}',
  ir: 'Biztosítási követelmények',
  location: 'Helyszín',
  pickup_location: 'Felvétel helyszíne',
  dropoff_location: 'Leadás helyszíne',
  vehicle: 'Gépjármű',
  pickup_and_dropoff: 'Felvétel és leadás (helyi idő)',
  view_voucher: 'Utalvány megtekintése',
  identity_verification_body: 'A gépjármű átvétele előtt igazolnia kell személyazonosságát',
  identity_verification_title: 'Személyazonosság ellenőrzése',
  search_again: 'Keresés újra',
  refrigerated: 'hűtve',
  aircon_lower: 'Légkondícionáló',
  aircon: 'Légkondícionáló',
  refrigeration: 'hűtés',
  not_available: 'Nem elérhető: A Drive & Go jelenleg csak az alábbi országokban kiállított személyazonosságot igazoló dokumentummal és vezetői engedéllyel rendelkező személyek számára érhető el.',
  check_if_included: 'Ellenőrizze, hogy benne van-e: Ellenőrizze, hogy az országa szerepel-e a felsorolásban.',
  included_in_booking: 'Ebben a foglalásban benne van',
  cdw_with_excess: 'CDW és önrész',
  theft_protection: 'Lopásvédelem önrésszel',
  risk_reduction: 'Kockázatcsökkentés',
  free_extras: 'Ezzel a foglalással Ön jogosult két ingyenes extra szolgáltatásra.',
  continue: 'Folytatás',
  luggage_large_short_label: 'L',
  luggage_medium_short_label: 'M',
  luggage_small_short_label: 'S',
  luggage_large_long_label: 'Nagy',
  luggage_medium_long_label: 'Közepes',
  luggage_small_long_label: 'Kicsi',
  fuel_unspecified_label: 'Nem meghatározott',
  transmission_manual_label: 'Manuális',
  transmission_automatic_label: 'Automata',
  make_a_booking: 'Foglalás',
  pickup_date: 'A felvétel dátuma',
  dropoff_date: 'A leadás dátuma',
  driver_age: 'A sofőr életkora 30-65 között',
  enter_driver_age: 'Kérjük, adja meg a sofőr életkorát',
  promo_code: 'Promóciós kód',
  search: 'Keresés',
  dropoff_date_cannot_be_before_pickup_date: 'A leadás dátuma nem lehet korábbi, mint a felvétel dátuma.',
  pickup_date_cannot_be_in_the_past: 'A felvételi dátum nem lehet a múltban.',
  pickup_time_cannot_be_in_the_past: 'A felvételi idő nem lehet a múltban.',
  dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Amennyiben a felvétel és a leadás azonos napon történik, úgy a leadási idő nem lehet korábbi a felvételi időnél',
  vehicle_filters: 'Gépjármű szűrők',
  reset: 'Visszaállítás',
  transmission: 'Váltó',
  all: 'Összes',
  manual: 'Manuális',
  auto: 'Automata',
  passengers: 'Utasok',
  vehicle_type: 'Gépjármű típus',
  filter: 'Szűrő',
  vehicle_search: 'Gépjármű kereső',
  edit: 'Szerkesztés',
  no_results: 'Nincs eredmény a megadott keresési feltételek alapján',
  small_cars: 'Kis gépjárművek',
  medium_cars: 'Közepes gépjárművek',
  large_cars: 'Nagy gépjárművek',
  estate_cars: 'Kombi gépjárművek',
  suvs: 'SUV gépjárművek',
  mpvs: 'MPV gépjárművek',
  vans: 'Tehergépjárművek',
  camper_vans: 'Lakókocsik',
  premium: 'Prémium',
  unspecified: 'meghatározatlan',
  large: 'nagy',
  medium: 'közepes',
  small: 'kicsi',
  automatic: 'automata',
  you_have_been_refunded: 'A befizetett összeg visszatérítésre került.',
  please_customer_service: 'Kérjük_ügyfélszolgálat: A foglaláshoz, kérjük, vegye fel a kapcsolatot ügyfelszolgálatunkkal.',
  contact_customer_service: 'Keresse_ügyfélszolgálat: Fegye fel a kapcsolatat az ügyfélszolgálatunkkal',
  booking_failed: 'a foglalás meghiúsult: A foglalását ezúttal nem tudtuk feldolgozni',
  summary: 'Összefoglaló',
  reforestation_and_protection: 'Újraerdősítés_és_védelem: Támogassa az esőerdők újraerdősítését és védelmét Costa Rica-szerte',
  cost_of_rental: 'A foglalás költségei',
  to_pay_now: 'Most fizetendő',
  greenheart_donation: 'Zöld szív adományozás',
  total_cost: 'Teljes_költség: A bérlés teljes költsége',
  tc_agreement: 'ÁSZF_megállapodás: Elolvastam és megértettem a ({0}).',
  tc: 'Általános Szerződési Feltételek',
  receive_offers: 'Szeretnék speciális ajánlatokat kapni emailben',
  donate: 'Igen, szeretnék adományozni {amount}',
  pay_now: 'Fizessen {amount} most',
  driver_details: 'Sofőr/ök adatai',
  complete_driver_details: 'Kérem, adja meg a sofőr adatait',
  are_you_the_driver: 'Ön a sofőr?',
  have_an_account: 'Önnek már van fiókja?',
  login: 'Bejelentkezés',
  or: 'vagy',
  first_name: 'Sofőr/ök keresztneve',
  last_name: 'Sofőr/ök vezetékneve',
  email: 'Email cím',
  phone_number: 'Mobil telefonszám',
  unable_to_save_driver_information: 'Nem sikerült elmenteni a sofőr adatait. Kérjük, próbálja újra.',
  pay_online_now: 'Fizessen online most',
  day: 'Nap',
  choose_location: 'Válasszon lokációt',
  location_not_found: 'Sajnáljuk, nem találtuk az Ön által kért lokációt',
  add: 'Hozzáad',
  remove: 'Törlés',
  free_extra: 'Ingyenes extra',
  free: 'Ingyenes',
  fast_track_notice: 'Erre a szolgáltatásra dokumentum származási korlátozások vonatkoznak. Csak olyan személyek számára érhető el, akiknek a dokumentumai a következő helyről származnak',
  complete_booking: 'Foglalás véglegesítése',
  choose_card: 'Kérjük, válasszon kártyát, vagy adjon meg egy újat.',
  add_billing_details: 'Kérjük, adja meg a számlázási adatokat.',
  card_number: 'Kártyaszám',
  card_holder_name: 'Kártyatulajdonos neve',
  card_exp: 'Hó/Év',
  card_cvc: 'CVC',
  save_card: 'Kártya mentése?',
  amount_charged: 'A kártyáját megterheljük',
  payment_confirmation: 'Foglalás megerősítése és fizetés',
  payment_methods: 'Elérhető fizetési lehetőségek',
  use_saved_card: 'Használjon mentett kártyát',
  use_different_card: 'Használjon új kártyát',
  book_now: 'Foglaljon most',
  minimum_age: 'túl {age}\ csak',
  excess_liability: 'Önrész kötelezettség',
  security_deposit: 'Biztonsági letét',
  fuel_policy: 'Üzemanyag irányelv',
  like_for_like: 'Kiadott üzemanyag szinttel megegyező mennyiséggel leadni',
  full_to_full: 'Kiadott üzemanyag szinttel megegyező mennyiséggel leadni',
  miles_per_rental: 'Szabad mérföld használat/bérlet',
  km_per_rental: 'Szabad kilométer használat/bérlet',
  unlimited_mileage: 'Korlátlan mérföld használat',
  unlimited_mileage_km: 'Korlátlan km',
  non_amendable: 'Nem módosítható',
  non_refundable: 'Nem visszatérítendő',
  free_cancellation_until: 'Ingyenesen lemondható amíg: Ingyenes lemondás a következő időpontig',
  cancellation_in_line_with: 'Lemondás a következőkkel összhangban',
  tcs: 'ÁSZF',
  free_extras_on_collection: 'Kettő ingyenes extra: kettő ingyenes extra az átvételkor',
  glass_and_tyres_covered: 'Az üveg és a gumiabroncs kár fedezve',
  number_of_passengers: 'Utasok száma',
  number_of_bags: 'Csomagok száma',
  fuel_type: 'Üzemanyag típus',
  co2: 'CO2',
  book_type: 'Foglalás {type}',
  processing: 'Feldolgozás',
  actual_price: 'Aktuális ár',
  tooltip: 'Az ár {currencyCode}-ban egy árfolyamon alapuló becslés, a {currency} pénznemben megadott ár kötelező. ',
  deposit: 'Kaució',
  pay_online: 'Fizessen online most',
  pay_online_without_extras: 'Bérleti díj',
  extras_on_arrival: 'Extrák érkezéskor',
  insurance_on_arrival: 'Kockázatcsökkentés-fizessen érkezéskor',
  insurance_online: 'Kockázatcsökkentés-fizessen most',
  extras_online: 'Extrák fizetése most',
  green_heart_donation: 'Zöld szív adományozás',
  why_use_drive_and_go: 'Miért válassza a Drive&Go-t?',
  straight_to_car: 'Egyenesen az autóhoz',
  no_queues: 'Sorbanállás nélkül',
  self_checkout: 'Önellenőrzés',
  cant_lose_key: 'Nem veszítheti el a kulcsot',
  online_id_check: 'Online ID ellenőrzés',
  phone_as_key: 'Telefon mint kulcs',
  premiumplus_benefits_includes: 'Premium Plus + juttatásokat is tartalmaz',
  book_drive_go: 'Foglaljon Drive&Go-t',
  distance_allowance: 'Távolsági díj',
  duration: 'Időtartam',
  view_more_bookings: 'További foglalások megtekintése',
  to_pay_on_arrival: 'Érkezéskor fizetni',
  pay_on_arrival: 'Fizessen érkezéskor',
  unlimited: 'Korlátlan',
  return_date: 'Leadási dátum',
  postcode: 'Postai irányítószám',
  country: 'Ország',
  drive_and_go: {
    drive_and_go: 'Drive and Go',
    available_countries: 'A Drive&Go jelenleg csak a következő országokból származó személyazonossági és vezetői engedélyekkel rendelkező személyek számára érhető el',
    drive_and_go_today: 'Drive & Go foglalás most!',
    drive_and_go_shortened: 'Drive & Go',
    why_use_drive_and_go: 'Miért válassza a Drive&Go-t?',
    straight_to_car: 'Egyenesen az autóhoz',
    no_queues: 'Sorbanállás nélkül',
    self_checkout: 'Önálló gépkocsifelvétel',
    cannot_lose_the_key: 'Nem veszítheti el a kulcsot',
    online_id_check: 'Online ID ellenőrzés',
    phone_as_a_key: 'Telefon mint kulcs',
    premium_plus_benefits_also_included: 'Premium Plus + juttatásokat is tartalmaz',
    book_drive_and_go: 'Book Drive & Go'
  },
  my_bookings: "Foglalásaim",
  no_bookings: "Nincsenek foglalások",
  my_profile: 'Saját profilom',
  no_bookings_to_display: 'Nincs megjeleníthető foglalás',
  search_great_car_rental_deals: "Keressen nagyszerű autóbérlési ajánlatokat a következő utazásához.",
  odometer_at_collection: 'Kilométeróra állása átvételkor',
  fuel_at_collection: 'Üzemanyagszint átvételkor',
  start_check_in: 'Kezdje meg a leadást',
  start_collection: 'Kezdje meg az átvételt',
  recent_bookings: 'Legutóbbi foglalások',
  damage: {
    updated_damage_report_submitted: 'Frissített kárjelentést nyújtottak be. Ügyfélszolgálatunk munkatársa szükség esetén az Ön rendelkezésére áll.',
    add_additional_damage: 'További sérülések hozzáadása',
    you_may_report_additional_damage_up_to: 'A gépjármű átvételét követő 24 óráig jelentheti a további károkat',
    specify_damage: 'Részletezze sérülést típusát',
    please_choose_the_area_and_type_of_damage: 'Kérjük, válassza ki az érintett területet és a sérülés típusát',
    type_of_damage: 'Sérülés típusa',
    is_this_more_than_5_cm: '5 cm-nél nagyobb a sérülés?',
    please_take_or_select_a_photo: 'Kérjük, készítsen vagy válasszon egy fényképet',
    please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Kérjük, készítsen egy fényképet, amelyen a sérülés jól látható',
    if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Ha szükséges, hozzáadhat egy másik fényképet, válassza ki az ikont egy másik fénykép hozzáadásához',
    save_image: 'Fotó mentése',
    save_images: 'Fotók mentése',
    damage_saved_successfully: 'A sérülés sikeresen rögzítésre került',
    add_photo: 'Fotó hozzáadása'
  },
  checkout: {
    start_collection: 'Kezdje meg az átvételt',
    collect_vehicle: 'Gépjármű felvétele',
    we_will_let_you_know_the_details: 'Tájékoztatni fogjuk Önt a gépjármű helyéről és megadjuk a szükséges információkat, hogy Ön könnyedén megtalálja a bérelt gépjárművet',
    inspect: 'Ellenőrizze',
    we_will_ask_for_four_photos_from_each_corner: 'Kérjük, készítsen fényképet a gépjármű mind a négy sarkáról, továbbá minden új sérülésről, amely még nem lett dokumentálva.',
    fuel_and_milage: 'Üzemanyag és kilométer-használat',
    you_confirm_the_readings_at_the_start_of_your_hire: 'Ön elismeri a kilométeróra állását és a gépjármű üzemanyag szintjét a bérlés kezdetén.',
    sign: 'Aláírás',
    sign_the_rental_agreement: 'Írja alá a bérleti szerződést.',
    away_you_go: 'Menj el',
    you_are_free_to_take_to_the_road: 'Útnak is indulhat.',
    collect_your_vehicle: 'Vegye át a gépjárművét',
    get_directions: 'Útbaigazítás',
    hide_directions: 'Útbaigazítás elrejtése',
    local_time: 'Helyi idő',
    tel: 'Telefonszám',
    getting_to_the_location: 'Eljutni a helyszínre',
    get_vehicle_details: 'A gépjármű adatainak lekérdezése',
    view_map: 'Térkép megtekintése',
    unlock_vehicle_and_continue: 'Nyissa ki a gépjárművet és folytassa',
    unable_to_connect_to_vehicle: 'Nem tud csatlakozni a járműhöz',
    we_were_unable_to_connect_to_the_vehicle_please_check: 'Nem tudtunk kapcsolódni a gépjárműhöz - kérjük, ellenőrizze, hogy a megfelelő gépjármű mellett áll-e, majd próbálja meg újra.',
    we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Nem sikerült megtalálnunk a gépjármű foglalást. Kérjük, próbálja újra később.',
    odometer_and_fuel: 'Kilométeróra és üzemanyag',
    odometer: 'Kilométeróra',
    please_confirm_the_odometer_and_fuel_readings: 'Ha lehetséges, kérjük, erősítse meg a kilométeróra és az üzemanyagmérő adatait',
    the_odometer_field_is_required: 'A kilométer-számláló mező kitöltése kötelező',
    and_must_be_greater_than_the_checkout_odometer: 'a kilométer-számláló állása többet kell, hogy mutasson, mint kiadáskor',
    confirm: 'Megerősítés',
    please_take_a_photo_from_each_corner_of_the_vehicle: 'Kérjük, készítsen egy-egy fényképet a gépjármű minden sarkáról',
    pre_existing_damage: 'Már meglévő sérülések',
    no_pre_existing_damage: 'Nincs meglévő sérülés',
    new_damage: 'Új sérülés',
    add_additional_damage: 'Adjon hozzá új sérülést',
    no_new_damage_to_report: 'Nincs új bejelenteni való sérülés',
    checkout_complete: 'Kiadás befejezve',
    start_rental: 'Bérlés megkezdése',
    congratulations_name_it_is_time_to_take_to_the_road: 'Gratulálunk ({customer_name}), útnak is indulhat.',
    we_are_unable_to_complete_your_vehicle_checkout: 'Nem tudjuk befejezni gépjárművének a kiadását.',
    please_do_the_following: 'Kérjük, tegye a következőket',
    remove_all_belonging_and_lock_the_vehicle: 'Távolítson el minden tárgyat, és zárja le a gépjárművet',
    lock_vehicle: 'Zárja le gépjárművét',
    once_you_have_contacted_customer_services: 'Miután kapcsolatba lépett az ügyfélszolgálattal',
    vehicle_location: 'Gépármű helye',
    collect_your: 'Gyűjtse össze a',
    from: 'Tól',
    key_in_glove_box: 'a kulcs a kesztyűtartóban van',

    keyholder: {
      not_detected: 'A kulcs nem található a kulcstartóban',
      not_detected_please_try_again: 'Kérjük, helyezze a kulcsot a kulcstartóba, majd próbálja meg újra.',

      not_installed: 'Kulcstartó nincs beszerelve',
      not_installed_please_contact_customer_service: 'Kulcstartó nincs beszerelve, kérjük, vegye fel a kapcsolatot az ügyfélszolgálattal',
    },
    keyring: {
      look_up_failed: 'Kulcstartó keresés sikertelen',
      look_up_failed_please_contact_customer_service: 'Kulcstartó keresés sikertelen, kérjük, lépjen kapcsolatba az ügyfélszolgálattal',
    },
    key: {
      invalid: 'A kulcs érvénytelen',
      invalid_please_contact_customer_service: 'Az Ön kulcsa érvénytelen, kérjük, vegye fel a kapcsolatot ügyfélszolgálatunkkal',

      expired: 'A kulcs lejárt',
      expired__please_contact_customer_service: 'Az Ön kulcsa lejárt, kérjük, vegye fel a kapcsolatot ügyfélszolgálatunkkal',
    }
  },
  checkin: {
    start_check_in: 'Kezdje meg a leadást',
    vehicle_location: 'Gépjármű helye',
    tell_us_where_you_have_parked: 'Tájékoztasson minket, hogy hol parkolta le gépjárművét.',
    fuel_and_milage: 'Üzemanyag & Kilométer-használat',
    you_confirm_the_readings_at_the_end_of_your_hire: 'A bérlés végén olvassa le a kilométeróra és üzemanyagmérő adatait.',
    inspect: 'Ellenőrizze',
    we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Kérjük, készítsen fényképet a gépjármű mind a négy sarkáról, valamint a bérlés során keletkezett új sérülésekről.',
    lock: 'Bezár/Zárja le',
    check_you_have_left_no_belonging_then_lock_the_vehicle: 'Ellenőrizze, hogy nem hagyott-e semmilyen tárgyat a gépjárműben, majd zárja le az autót.',
    please_tell_us_where_you_have_parked_the_vehicle: 'Kérjük, közölje velünk, hogy hol parkolta le a gépjárművet.',
    once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Ha a gépjárművet már lezárta, nem fogja tudja újra kinyitni.',
    name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '({first_name}) kérjük, ellenőrizze, hogy nem hagyott-e semmilyen tárgyat a gépjárműben, majd zárja le az autót, és ha szükséges, a kulcsot adja oda az illetékes személynek.',
    lock_vehicle: 'Zárja le a gépjárművet.',
    complete_check_in: 'Végezze el a gépjármű leadását.',
    inspection: 'Ellenőrzés',
    complete_vehicle_check_in: 'Végezze el a gépjármű leadását.',
    we_are_unable_to_complete_your_vehicle_check_in: 'Nem tudjuk elvégezni az Ön gépjárművének a leadási folyamatát.',
    please_contact_customer_services: 'Kérjük, vegye fel a kapcsolatot ügyfélszolgálatunkkal.',
    once_you_have_contacted_customer_services: 'Miután kapcsolatba lépett az ügyfélszolgálattal',
    please_amend_odometer_to_be_greater_than: 'Kérjük, módosítsa a kilométeróra állását, hogy nagyobb legyen, mint ({odometer_value})',
  },
  rental_agreement: {
    rental_agreement: 'Bérleti megállapodás',
    agreement_between: 'Megállapodás (x és y között)',
    and: 'és',
    sign_rental_agreement: 'Írja alá a bérleti szerződést',
    i_have_read_and_understood_the_terms_and_conditions: 'Elolvastam és megértettem az Általános Szerződési Feltételeket, és elfogadom a gépjármű állapotát.',
  },
  additional_options: 'További lehetőségek',
  booking_details: 'Foglalás részletei',
  price_for_x_days: 'Ár {qty_of_days} napra | Ár {qty_of_days} napra',
  cancelled: 'Törölve',
  upcoming: 'Közelgő',
  active: 'Aktív',
  full_insurance_no_deposit: 'Teljes körű biztosítás & nincs szükség kaucióra',
  excess: '{amount} Önrész',
  deposit: '{amount} Kaució',
  included_daily_distance: '{distance} {unit} per nap',
  miles: 'Mérföld',
  kilometers: 'Kilométer',
  collection_details_title: 'Átvétel adatai',
  collection_details_not_found: 'Ehhez a lokációhoz nincsenek átvételi adatok definiálva',
  free_cancellation: 'Ingyenes visszavonás',
  no_deposit: 'Nincs letét',
  benefit_from: 'Részesülnek',
  for_only_per_day: 'Csak ({price}) naponta',
  upgrade_mee: 'UpgradeMee'
}
